const ROLE_OWNER = 0
const ROLE_ADMIN = 1

export function resolveRoleTag(role, roleLabel) {
  const roleValue = Number(role)
  if (roleValue !== ROLE_OWNER && roleValue !== ROLE_ADMIN) {
    return {
      showRoleTag: false,
      roleTagClass: '',
      roleTagLabel: '',
    }
  }
  let roleTagClass = ''
  if (roleValue === ROLE_OWNER) {
    roleTagClass = 'chat-group-history__role-tag--owner'
  } else if (roleValue === ROLE_ADMIN) {
    roleTagClass = 'chat-group-history__role-tag--admin'
  }
  const labelMap = {
    [ROLE_OWNER]: '群主',
    [ROLE_ADMIN]: '管理员',
  }
  return {
    showRoleTag: true,
    roleTagClass,
    roleTagLabel: roleLabel || labelMap[roleValue] || '',
  }
}
